import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import host from "../../config";
const ChinamushidiwadaKalyanamandapam = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // Only depends on id



  const pricingData = [
    {
      id: 1,
      purpose: "Ground Floor",
      rent: 65000,
      deposit: 30000,
      gst: 12060,
      cleaning: 2000,
      total: 109060,
    },
    {
      id: 2,
      purpose: "1st Floor",
      rent: 45000,
      deposit: 30000,
      gst: 8550,
      cleaning: 2500,
      total: 86050,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        {/* Hero Section */}
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.map((item, idx) => (
              <div key={idx} className="carousel-image">
                <img src={item.url} alt={`Chinamushidiwada Image ${idx + 1}`} />
                <div className="overlay">
                  <h1>Chinamushidiwada Kalyanamandapam</h1>
                  <p>Spacious Event Venue in Vizag</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {/* Venue Details */}
        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Chinamushidiwada Kalyanamandapam</strong> is situated on a
            sprawling area of 6009.26 Sq.yds with a building plinth area of
            1748.74 Sq.yds and a vacant area of 4260.52 Sq.yds. This spacious
            venue offers ample parking and is ideal for weddings, receptions,
            and large gatherings.
          </p>
          <h3>Floor Details</h3>
          <ul className="floor-details">
            <li>
              Ground Floor: Plinth Area - 15,738.66 sft | Carpet Area - 8,354.30
              sft
            </li>
            <li>
              1st Floor: Plinth Area - 15,896.25 sft | Carpet Area - 8,354.30
              sft
            </li>
            <li>
              Mezzanine Floor: Plinth Area - 4,019.67 sft | Carpet Area -
              2,455.68 sft
            </li>
            <li>Total Area: 35,654.38 sft | Carpet Area - 19,164.28 sft</li>
          </ul>

          {/* Pricing Section */}
          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign /> Total:{" "}
                  <strong>{item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          {/* Contact Section */}
          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Chinamushidiwada, Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@chinamushidiwadakalyanamandapam.com
            </p>
          </div>

          {/* Book Now Button */}
          <Link to="/" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ChinamushidiwadaKalyanamandapam;
